import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { buildChartPalette } from '../utils/chartTheme';

export default function useAnalyticsTheme() {
  const theme = useTheme();
  return useMemo(
    () => ({
      accent: theme.palette.chat,
      shadows: theme.customTokens?.shadows,
      semantic: theme.customTokens?.semantic,
      chartColors: buildChartPalette(theme),
    }),
    [theme]
  );
}
